import type { IconButtonProps } from '@rjsf/utils'
import { Mtds } from 'prove-common'

export const RemoveButton = ({ onClick }: IconButtonProps) => (
  <Mtds.Button onClick={onClick}>Fjern</Mtds.Button>
)
